import React, { useState } from 'react';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        message: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [submissionError, setSubmissionError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors({
            ...errors,
            [name]: '', // Clear error when user types
        });
        setSubmissionError(''); // Clear submission error when user types
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
        if (!formData.message) newErrors.message = 'Message is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        // Send form data to Formspree
        const response = await fetch(`https://formspree.io/f/${process.env.REACT_APP_MAIL_KEY}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        if (response.ok) {
            setSubmitted(true);
            setFormData({
                name: '',
                email: '',
                message: '',
            });
            setErrors({
                name: '',
                email: '',
                message: '',
            });
            setSubmissionError('');
            // Clear the success message after 4 seconds
            setTimeout(() => setSubmitted(false), 4000);
        } else {
            setSubmissionError('Failed to send message. Please try again.');
        }
    };

    return (
        <>
            <h2><span className='text-blue-500'>K</span>eep in touch</h2>
            <hr />
            <br />
            <form onSubmit={handleSubmit}>
                <div className="-m-2 flex flex-wrap">
                    <div className="w-1/2 p-2">
                        <div className="relative">
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`peer w-full rounded border py-1 px-3 text-base leading-8 placeholder-transparent outline-none transition-colors duration-200 ease-in-out ${errors.name ? 'border-red-500 focus:border-red-500' : 'border-blue-300 focus:border-blue-500'} focus:ring-0.5`}
                                placeholder="Name"
                            />
                            <label htmlFor="name" className="absolute left-3 -top-6 text-sm leading-7 text-blue-500 transition-all peer-placeholder-shown:left-3 peer-placeholder-shown:top-2 peer-placeholder-shown:text-blue-900 peer-placeholder-shown:text-base peer-focus:left-3 peer-focus:-top-6 peer-focus:text-sm">Name</label>
                            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                        </div>
                    </div>
                    <div className="w-1/2 p-2">
                        <div className="relative">
                            <input
                                type="text" // Changed to text to prevent default email validation
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`peer w-full rounded border py-1 px-3 text-base leading-8 placeholder-transparent outline-none transition-colors duration-200 ease-in-out ${errors.email ? 'border-red-500 focus:border-red-500' : 'border-blue-300 focus:border-blue-500'} focus:ring-0.5`}
                                placeholder="Email"
                            />
                            <label htmlFor="email" className="absolute left-3 -top-6 text-sm leading-7 text-blue-500 transition-all peer-placeholder-shown:left-3 peer-placeholder-shown:top-2 peer-placeholder-shown:text-blue-900 peer-placeholder-shown:text-base peer-focus:left-3 peer-focus:-top-6 peer-focus:text-sm">Email</label>
                            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                        </div>
                    </div>
                    <div className="mt-4 w-full p-2">
                        <div className="relative">
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                className={`peer w-full rounded border h-60 py-1 px-3 text-base leading-8 placeholder-transparent outline-none transition-colors duration-200 ease-in-out ${errors.message ? 'border-red-500 focus:border-red-500' : 'border-blue-300 focus:border-blue-500'} focus:ring-0.5`}
                                placeholder="Message"
                            ></textarea>
                            <label htmlFor="message" className="absolute left-3 -top-6 text-sm leading-7 text-blue-500 transition-all peer-placeholder-shown:left-3 peer-placeholder-shown:top-2 peer-placeholder-shown:text-blue-900 peer-placeholder-shown:text-base peer-focus:left-3 peer-focus:-top-6 peer-focus:text-sm">Message</label>
                            {errors.message && <p className="text-red-500 text-xs mt-1">{errors.message}</p>}
                        </div>
                    </div>
                    <div className="w-full p-2">
                        <button type='submit' className="mx-auto flex rounded border border-blue-500 py-2 px-8 text-lg hover:bg-blue-200 text-black focus:outline-none">
                            Send Message
                        </button>
                    </div>
                </div>
            </form>

            {submitted && (
                <div className="mt-4 text-center text-green-500">
                    Your message has been sent!
                </div>
            )}
            {submissionError && (
                <div className="mt-4 text-center text-red-500">
                    {submissionError}
                </div>
            )}
        </>
    );
};

export default ContactForm;
